<div class="hds-list-item margin-v-xs bg-transparent bg-hover cursor-hover">

  <a (click)="onClickOnArticleItem()">
    <div class="grid-x">
      <div class="cell shrink">
        <div style="position: relative;" class="hoverable">
          <div *ngIf="article.thumbnailUrl"
               class="actu-image-event"
               style="opacity: 1; transition: all 0.5s ease;"
               [style.background-image]="'url(' + article.thumbnailUrl + ')'">
          </div>
          <div *ngIf="isCurrentArticle" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <i class="fa fa-play-circle c-filter" style="font-size: 20px;"></i>
          </div>
        </div>

      </div>
      <div class="cell auto">
        <div class="d-block padding-l-s">
          <span class="i-block margin-b-xs f-7 font-bold c-black overflow-ellipsis">
            {{article.title}}
          </span>
          <br/>
          {{article.lastPublicationDate | date:'dd/MM/yyyy'}} - {{article.author}}
        </div>
      </div>

      <div>
        <a (click)="onClickTrackAction($event)"
           [href]="articleUrl"
           target="_blank"
           class="button hollow insito border-radius-default float-right padding-all-xs margin-t-s">
          {{'widget.publications.show' | translate}}
        </a>
      </div>
    </div>
  </a>
</div>
